

export const baseStore = {
  state: {
    count: 0
  },
  mutations: {
    increment(state) {
      state.count++
    }
  }
};